import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import useModal from '@src/utils/hooks/use-modal';
import CommonModal from '@src/business-components/common-modal';
import CommonModalStore from '@src/business-components/common-modal/store';
import ShareModal from '@src/business-components/share-modal';
import ShareModalStore from '@src/business-components/share-modal/store';
import ReceiveAwardModal from '@src/business-components/receive-award-modal';
import ReceiveAwardModalStore from '@src/business-components/receive-award-modal/store';
import RuleModal from '@src/business-components/rule-modal';
import RuleModalStore from '@src/business-components/rule-modal/store';
import DrawRecordListModal from '@src/business-components/draw-record-list-modal';
import DrawRecordListModalStore from '@src/business-components/draw-record-list-modal/store';
import BaseStore from '@src/utils/store/base-store';
import AntdMessage from '@src/components/antd/message';
import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import $$tracker from '@src/tracker';

class DrawStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable isActive = false;

  // 抽獎列表
  @observable
  drawAwardList = [
    {
      id: 1,
      label: '全新限时售卖时装',
      btn_url: require('./images/drawItem1.png')
    },
    {
      id: 2,
      label: 'Steam Deck OLED 1TB',
      btn_url: require('./images/drawItem2.png')
    },
    {
      id: 3,
      label: '天启者共鸣誓约*10',
      btn_url: require('./images/drawItem3.png')
    },
    {
      id: 4,
      label: '随机特典明信片',
      btn_url: require('./images/drawItem4.png')
    },
    {
      id: 5,
      label: '随机全新时装立牌',
      btn_url: require('./images/drawItem5.png')
    },
    {
      id: 6,
      label: '随机亚克力流沙摆件*1',
      btn_url: require('./images/drawItem6.png')
    },
    {
      id: 7,
      label: '数据金*50',
      btn_url: require('./images/drawItem7.png')
    },
    {
      id: 8,
      label: '天启者心意补给',
      btn_url: require('./images/drawItem8.png')
    }
  ];

  // 任务配置列表
  @computed
  get missionConfigs() {
    return [
      {
        type: 'watchVideo',
        title: '观看活动PV',
        completed: this.watchVideoMissionState,
        reward: '可得1次机会'
      },

      {
        type: 'dailyShare',
        title: '完成每日分享网页',
        completed: this.dailyShareMissionState || this.dailyShareMissionTimes >= this.dailyShareMissionMax,
        reward: this.dailyShareTips
      },
      {
        type: 'followWeibo',
        title: '完成关注官方微博账号',
        completed: this.focusWeiboMissionState,
        reward: '可得1次机会',
        href: this.mainStore.loginState && this.activityStatus !== 0 ? 'https://weibo.com/u/7573935610' : undefined
      },
      {
        type: 'followBilibili',
        title: '完成关注官方B站账号',
        completed: this.focusBiliBiliMissionState,
        reward: '可得1次机会',
        href: this.mainStore.loginState && this.activityStatus !== 0 ? 'https://space.bilibili.com/1409863611?spm_id_from=333.337.0.0' : undefined
      },
      {
        type: 'review',
        title: '完成趣味H5网页活动《与你的爱之誓言》',
        completed: this.review_share_status,
        reward: '可得1次机会'
      }
    ];
  }

  @observable mainStore;

  // 抽奖活动状态
  @observable activityStatus = 0;

  // 用户抽奖次数
  @observable prizeChance = 0;

  // 是否抽到了实物奖励
  @observable isGetRareReward = false;

  // 中奖弹窗请求锁
  @observable receiveAwardRequestLock = false;

  // 抽奖请求锁
  @observable lotteryRequestLock = false;

  // 当前任务类型
  @observable missionType;

  // 任务触发入口
  @observable missionEntryPos;

  // 是否完成分享周年回顾任务
  @observable review_share_status = false;

  // 观看PV是否完成
  @observable watchVideoMissionState = false;

  // 关注微博任务完成状态
  @observable focusWeiboMissionState = false;

  //关注b站任务完成状态
  @observable focusBiliBiliMissionState = false;

  // 每日分享任务完成状态（1：今日已完成，0：今日未完成）
  @observable dailyShareMissionState = false;

  // 每日分享任务完成总次数（活动期间累计）
  @observable dailyShareMissionTimes = 0;

  // 每日分享任务最多次数（活动期间上限3次）
  @observable dailyShareMissionMax = 3;

  // 登录游戏模块是否开放;
  @observable loginGameState = 0;

  // 登录游戏次数
  @observable loginGameTimes = 0;

  // 今日登录游戏状态
  @observable todayLoginGameState = false;

  // 抽奖记录使用弹窗类型
  @observable lotteryModalType = '';

  // 规则弹窗
  ruleModalStore = new RuleModalStore({});
  // 分享弹窗
  shareModalStore = new ShareModalStore({});
  // 中奖登记
  receiveAwardModalStore = new ReceiveAwardModalStore();
  // 中奖记录
  drawRecordListModalStore = new DrawRecordListModalStore({
    drawStore: this
  });

  // 通用弹窗
  commonModalStore = new CommonModalStore();

  // 剩余可获得的分享次数
  @computed
  get remainingShareTime() {
    return this.dailyShareMissionMax - this.dailyShareMissionTimes;
  }

  // 每日分享任务提示
  @computed
  get dailyShareTips() {
    if (this.dailyShareMissionTimes >= this.dailyShareMissionMax) {
      return '已获取3次机会';
    }
    if (this.dailyShareMissionState) {
      return `还可得${this.remainingShareTime}次机会`;
    }
    return '每日可分享一次，至多可得3次机会';
  }

  // 抽奖按钮是否禁用
  @computed
  get isDrawBtnDisabled() {
    return this.mainStore.loginState && (this.prizeChance <= 0 || this.lotteryRequestLock);
  }

  // 获奖登记按钮是否禁用
  @computed
  get isReceiveAwardBtnDisabled() {
    return this.mainStore.loginState && !this.isGetRareReward;
  }

  // 游戏登录进度文本
  @computed
  get gameLoginProgressText() {
    return `游戏内登录网页（${this.todayLoginGameState || this.loginGameTimes >= 5 ? this.loginGameTimes : 0}/5）`;
  }

  //刷新抽奖次数
  clickRefresh = () => {
    if (this.mainStore.loginState) {
      // 确保在刷新数据时解锁抽奖锁，避免锁状态影响后续抽奖
      this.lotteryRequestLock = false;
      this.mainStore.getConfig.run();
    } else {
      this.mainStore.onLogin();
    }
  };

  /**
   * 执行任务增加抽奖次数
   * @param type 任务类型
   * （1：查看PV，2：分享第一天，3：分享第二天，4：分享第三天，5：前往H5，6：订阅B站，7：订阅微博）
   *
   */
  onAddChanceByExecuteMission = type => {
    if (this.mainStore.loginState) {
      if (this.activityStatus === 0) {
        AntdMessage.error('活动未开始');
        return;
      }
      switch (type) {
        case 'review':
          this.mainStore.changeMenu(2);
          break;
        case 'watchVideo':
          this.mainStore.changeMenu(0);
          break;
        case 'followWeibo':
          $$tracker.clickGoFollow('微博', '抽奖任务');
          this.followWeiboCallback();
          break;
        case 'followBilibili':
          $$tracker.clickGoFollow('B站', '抽奖任务');
          this.followBiliBiliCallback();
          break;
        case 'dailyShare':
          this.modals.shareModal.open();
          break;
        default:
          break;
      }
    } else {
      this.mainStore.onLogin();
    }
  };

  /**
   * 执行任务
   * @param missionId
   * @returns {boolean}
   */
  onExecuteMission = missionId => {
    if (!missionId) {
      return false;
    }

    // 检查 onExecuteMissionAddChance 是否已经初始化
    if (this.onExecuteMissionAddChance && typeof this.onExecuteMissionAddChance.run === 'function') {
      this.onExecuteMissionAddChance.run(missionId);
    }
  };

  /**
   *  抽奖
   * @return
   */
  getPrizeResult = async () => {
    if (this.activityStatus === 0) {
      AntdMessage.error('活动未开始');
      return null;
    }
    if (this.activityStatus === 2) {
      AntdMessage.error('活动已结束');
      return null;
    }

    // 检查抽奖锁，防止重复请求
    if (this.lotteryRequestLock) {
      return null;
    }

    // 设置抽奖锁
    this.lotteryRequestLock = true;

    try {
      const res = await this.$ztService.lottery();

      //中奖是否匹配
      const resultData = this.drawAwardList.find(item => {
        return item.id === res.prize_id;
      });

      if (resultData) {
        $$tracker.clickRaffle('success', '');

        //如果为1则为获取实物奖励
        if (res.prize_type === 1) {
          this.isGetRareReward = true;
        }
        //提示信息
        const prizeTips =
          res.prize_type === 1 ? '请前往登记收货地址' : '*奖品将通过游戏内邮件发送至游戏账号，可能存在延迟，预计10分钟内到账，请分析员耐心等待~';
        //抽奖次数减少
        this.prizeChance--;
        //中奖图片
        this.commonModalStore.image = resultData.btn_url;
        //中奖信息
        this.commonModalStore.text = `恭喜获得：${this.drawAwardList[res.prize_id - 1].label}`;
        //中奖提示
        this.commonModalStore.tips = prizeTips;
        //如果是实物打开中奖登记弹框
        this.commonModalStore.clickSubmitCallback = res.prize_type === 1 ? this.onClickOpenReceiveAwardModal : undefined;
        return resultData;
      }
    } catch (error) {
      const errorMessage = error.serviceResponse?.message || error.message;
      $$tracker.clickRaffle('fail', errorMessage);

      AntdMessage.error(error.serviceResponse?.message);
      this.clickRefresh();
      throw error;
    } finally {
      this.lotteryRequestLock = false;
    }
  };

  /**
   * 抽奖完成回调
   * @param result 结果
   */
  prizeComplete(result) {
    // console.log(result);
    this.modals.commonModal.open();
    // 确保抽奖完成后解锁
    this.lotteryRequestLock = false;
  }

  /**
   * 观看PV成功回调
   */
  watchVideoCallback = () => {
    if (this.mainStore.loginState && !this.watchVideoMissionState) {
      this.onExecuteMission('1');
    }
  };

  /**
   * 分享成功回调
   */
  shareSuccessCallback = () => {
    clearTimeout(this.shareTimer);
    this.shareTimer = setTimeout(() => {
      // 检查是否满足执行任务的条件
      if (!this.mainStore.loginState || this.dailyShareMissionTimes >= this.dailyShareMissionMax || this.dailyShareMissionState) {
        return;
      }
      //分享 2：分享第一天，3：分享第二天，4：分享第三天
      switch (this.dailyShareMissionTimes) {
        case 0:
          this.onExecuteMission('2');
          break;
        case 1:
          this.onExecuteMission('3');
          break;
        case 2:
          this.onExecuteMission('4');
          break;
        default:
      }
    }, 3000);
  };

  /**
   * 分享H5成功回调
   */
  followH5Callback = () => {
    if (this.mainStore.loginState && !this.review_share_status) {
      this.onExecuteMission('5');
    }
  };

  /**
   * 关注b站成功回调
   */
  followBiliBiliCallback = () => {
    if (this.mainStore.loginState && !this.focusBiliBiliMissionState) {
      this.onExecuteMission('6');
    }
  };

  /**
   * 关注官博成功回调
   */
  followWeiboCallback = () => {
    if (this.mainStore.loginState && !this.focusWeiboMissionState) {
      this.onExecuteMission('7');
    }
  };

  /**
   * 点击登录游戏按钮
   * @returns {boolean}
   */
  onClickGameLogin = () => {
    if (this.mainStore.loginState) {
      if (this.activityStatus === 0 || this.loginGameState === 0) {
        AntdMessage.error('活动未开始');
        return;
      }
      if (this.loginGameState === 2) {
        AntdMessage.error('活动已结束');
        return;
      }
      if (this.loginGameTimes >= 5) {
        return false;
      }
      const tipsText = this.todayLoginGameState ? '今日次数已经获得，明日再来吧~' : '请前往游戏内登录该页面，以完成任务';
      AntdMessage.info(tipsText);
    } else {
      this.mainStore.onLogin();
    }
  };

  // 点击规则弹窗
  onClickOpenRule = () => {
    this.modals.ruleModal.open();
  };

  // 打开中奖登记弹窗
  onClickOpenReceiveAwardModal = (isFromRewardModal = false) => {
    if (this.mainStore.loginState) {
      if (!this.receiveAwardRequestLock) {
        this.receiveAwardRequestLock = true;
        // 将记录状态标记为中奖登记
        this.lotteryModalType = 'checkIn';
        this.getLotteryLog.run();
      }
    } else {
      this.mainStore.onLogin();
    }
  };

  // 打开中奖记录弹窗
  onClickOpenRecordListModal = () => {
    if (this.mainStore.loginState) {
      if (!this.receiveAwardRequestLock) {
        this.receiveAwardRequestLock = true;
        // 将记录状态标记为中奖登记
        this.lotteryModalType = 'lotteryRecord';
        this.getLotteryLog.run();
      }
    } else {
      this.mainStore.onLogin();
    }
  };

  /**
   * 点击退出登录
   */
  onClickLogout = () => {
    this.mainStore.onLogout();
  };

  /**
   * 点击登录
   */
  onClickLogin = () => {
    this.mainStore.onLogin();
  };

  /**
   * 手动更新任务状态
   * @param missionId
   * @param newState
   * （1：查看PV，2：分享第一天，3：分享第二天，4：分享第三天，5：前往H5，6：订阅B站，7：订阅微博）
   */
  updateMissionState = (missionId, newState) => {
    switch (missionId) {
      case '1':
        this.watchVideoMissionState = newState;
        break;
      case '2':
      case '3':
      case '4':
        this.dailyShareMissionTimes = this.dailyShareMissionTimes + 1;
        this.dailyShareMissionState = newState;
        break;
      case '5':
        this.review_share_status = newState;
        break;
      case '6':
        this.focusBiliBiliMissionState = newState;
        break;
      case '7':
        this.focusWeiboMissionState = newState;
        break;
      default:
        break;
    }
  };

  /**
   * 执行完成任务
   * @param type
   * @returns
   */
  onExecuteMissionAddChanceAsync = type => {
    /* 任务类型（2：下载游戏，3：关注微博，4：每日分享） */
    this.missionType = type;
    return this.$ztService.missionDone(type);
  };

  /**
   * 获取抽奖记录
   * @returns
   */
  getLotteryLogAsync = () => {
    return this.$ztService.lotteryLog();
  };

  use() {
    super.use();
    // 执行任务获取次数
    this.onExecuteMissionAddChance = useRequest(async type => await this.onExecuteMissionAddChanceAsync(type), {
      manual: true,
      onSuccess: data => {
        // 更新任务完成的次数
        AntdMessage.success('任务完成! 抽奖次数+1!');
        this.prizeChance = this.prizeChance + data.inc_lottery_time;
        this.missionEntryPos = '';

        this.updateMissionState(this.missionType, true);
      },
      onError: e => {
        if (e.serviceResponse.code.toString() === '-20104') {
          switch (this.missionType) {
            case '4':
              AntdMessage.info('您已完成分享任务，已经获取过1次抽奖机会啦，无法再二次获取啦。');
              break;
            default:
              break;
          }
        }
        AntdMessage.error(e?.message);
      }
    });
    // 获取抽奖记录
    this.getLotteryLog = useRequest(async () => await this.getLotteryLogAsync(), {
      manual: true,
      onSuccess: data => {
        // 是否抽到了实物奖励
        this.isGetRareReward = data.is_get_entity_prize;

        this.receiveAwardRequestLock = false;
        if (this.lotteryModalType === 'checkIn') {
          if (!this.isGetRareReward) {
            AntdMessage.info('尚未获得实物奖励，快去抽奖吧~');
            return false;
          }
          const rareRewardIndex = data.log.findIndex(item => item.prize_type === '1');
          const rareRewardObj = this.drawAwardList[+data.log[rareRewardIndex].prize_id - 1];
          this.receiveAwardModalStore.rewardObj = rareRewardObj;

          if (data.address.receiver) {
            this.receiveAwardModalStore.isCheckModal = true;
            this.receiveAwardModalStore.isFinished = true;

            this.receiveAwardModalStore.nameInput.onChange(data.address.receiver);
            this.receiveAwardModalStore.phoneInput.onChange(data.address.phone);
            this.receiveAwardModalStore.addressInput.onChange(data.address.address);
          }
          this.modals.receiveAwardModal.open();
        }
        // 查看抽奖记录
        if (this.lotteryModalType === 'lotteryRecord') {
          this.drawRecordListModalStore.recordList = data.log;
          this.modals.drawRecordListModal.open();
        }
      },
      onError: e => {
        this.receiveAwardRequestLock = false;

        // 活动已结束仍然显示弹框
        if (e.serviceResponse?.code === -10154) {
          if (this.lotteryModalType === 'checkIn') {
            this.onClickOpenReceiveAwardModal();
          } else if (this.lotteryModalType === 'lotteryRecord') {
            this.onClickOpenRecordListModal();
          }
        } else {
          AntdMessage.error(e?.message);
        }
      }
    });

    // 弹窗
    this.modals = {
      ruleModal: useModal(RuleModal, { store: this.ruleModalStore }),
      commonModal: useModal(CommonModal, { store: this.commonModalStore }),
      shareModal: useModal(ShareModal, { store: this.shareModalStore }),
      receiveAwardModal: useModal(ReceiveAwardModal, { store: this.receiveAwardModalStore }),
      drawRecordListModal: useModal(DrawRecordListModal, { store: this.drawRecordListModalStore })
    };

    useMount(() => {
      this.shareModalStore.successCallback = this.shareSuccessCallback;
    });

    useEffect(
      () => {
        window.appointmentLoginState = this.mainStore.loginState;
      },
      [this.mainStore.loginState]
    );

    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 3;
      },
      [this.mainStore.pageSwiperIndex]
    );

    useEffect(
      () => {
        if (this.mainStore.loginState) {
          this.getLotteryLog.run();
        }
      },
      [this.mainStore.loginState]
    );
  }
}

export default DrawStore;
